import { urls } from "app/constants";
import { useApi } from "./index";
// import { dtoFormikServerErr, dtoProfile } from "app/utils/dto";

export const useApiProfile = () => useApi({ url: urls.profile, method: "get" });
